import { QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra';
import { constants } from '@wix/premium-cart-common';
const service = {
  baseUrl: '/_serverless/premium-cart-serverless'
};
async function dynamicLoadQueries(httpClient) {
  return (await import('../premium-cart-serverless.api-client')).PremiumCartServerlessApiClient.queries({
    httpClient
  });
}
export const PremiumCartServerlessApiConfig = {
  getSuccessData: {
    name: 'getSuccessData',
    service,
    path: constants.ENDPOINTS.getSuccessData.path,
    httpMethod: 'get',
    queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH
  },
  getProductTypeDetails: {
    name: 'getProductTypeDetails',
    service,
    path: constants.ENDPOINTS.getProductTypeDetails.path,
    httpMethod: 'get',
    queryConfigType: QueryConfigTypes.FIXED_DATA
  },
  listProductTypeDetails: {
    name: 'listProductTypeDetails',
    service,
    queryFn: async _ref => {
      let {
        httpClient,
        request
      } = _ref;
      const {
        getProductTypeDetails
      } = await dynamicLoadQueries(httpClient);
      const getProductTypePromises = request.productTypeIds.map(productTypeId => getProductTypeDetails({
        productTypeId,
        msid: request.msid
      }));
      return {
        productTypesDetails: await Promise.all(getProductTypePromises)
      };
    }
  }
};
//# sourceMappingURL=premium-cart-serverless.api-config.js.map